import { createSlice } from '@reduxjs/toolkit';
import { setGooglePayButtonVisibility } from '../../actions/googlePay/common';
import { GooglePayStore } from '../../types/StoreState';

const initialState: GooglePayStore['button'] = {
  visibility: 'initial',
};

const googlePayButtonSlice = createSlice({
  name: 'googlePayButton',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setGooglePayButtonVisibility, (state, action) => {
      state.visibility = action.payload;
    });
  },
});

export const googlePayButtonReducer = googlePayButtonSlice.reducer;
